export const DATA_ENRICHMENT_TARGET_FIELD_OPTIONS = Object.freeze([
  "name",
  "legal_name",
  "fiscal_code",
  "vat_number",
  "registration_number",
  "iban",
  "business_category",
  "business_is_active",
  "industry",
  "company_size",
  "employees_count",
  "annual_revenue",
  "website",
  "email_primary",
  "email_secondary",
  "email_tertiary",
  "phone_primary",
  "phone_secondary",
  "phone_tertiary",
  "address_text",
  "country",
  "linkedin",
  "facebook",
  "instagram",
  "administrator_name",
  "tags",
  "notes",
].map((value) => ({ value, label: value })));

export const DEDUP_FIELD_OPTIONS = Object.freeze([
  { value: "registration_ids", label: "Fiscal / VAT / registration" },
  { value: "phone_all", label: "Phone - all 3 fields" },
  { value: "email_all", label: "Email - all 3 fields" },
  { value: "social_profiles", label: "Social profiles" },
  "name",
  "legal_name",
  "fiscal_code",
  "vat_number",
  "registration_number",
  "website",
  "email_primary",
  "email_secondary",
  "email_tertiary",
  "phone_primary",
  "phone_secondary",
  "phone_tertiary",
  "address_text",
  "country",
  "instagram",
  "facebook",
  "linkedin",
  "business_category",
  "industry",
  "administrator_name",
  "old_reference",
].map((option) => (typeof option === "string" ? { value: option, label: option } : option)));
